<script setup>
defineProps({
  width: {
    type: String,
    default: '100%',
  },
  height: {
    type: String,
    default: '1rem',
  },
  circle: {
    type: Boolean,
    default: false,
  },
  rounded: {
    type: String,
    default: 'rounded-md',
  },
})
</script>

<template>
  <div
    class="bg-neutral-20 animate-pulse"
    :class="circle ? 'rounded-full' : rounded"
    :style="{ width, height: circle ? width : height }"
    aria-hidden="true"
  />
</template>
